import { render, staticRenderFns } from "./preview-wechat.vue?vue&type=template&id=fe514ff4&scoped=true&"
import script from "./preview-wechat.vue?vue&type=script&lang=js&"
export * from "./preview-wechat.vue?vue&type=script&lang=js&"
import style0 from "./preview-wechat.vue?vue&type=style&index=0&id=fe514ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe514ff4",
  null
  
)

export default component.exports